import { error as errorEvent, ErrorPageType } from 'lib/trackingEvents';
import { ApiError } from 'lib/error';
import { usePageView } from 'data/tracking/usePageView';
import { usePageViewV2 } from 'data/tracking/usePageViewV2';
import { error as errorEvents } from 'lib/trackingEventsV2';
import { usePlan } from 'data/plan/usePlan';

export const getErrorDetail = (error: ApiError) =>
  error.message ? error.message : '';

export const useErrorPageView = (errorType: ErrorPageType, error: ApiError) => {
  const { planType } = usePlan();
  // TODO: MUP event migration - clean up once all events are migrated
  usePageView(
    errorEvent.getPageView(errorType, error.code, getErrorDetail(error)),
  );
  usePageViewV2(
    errorEvents.pageView(errorType, planType, {
      type: error.type,
      code: error.code,
    }),
  );
};
